import React from 'react';
import { Archive, MousePointer2, Navigation } from 'lucide-react';
import { T } from './constants';

export const MinimapView = ({ treeData, selectedNode, selectNode, setViewMode }) => (
  <div className="flex-1 overflow-y-auto pr-2 space-y-4">
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-lg font-extrabold tracking-tight">Minimap Depozit</h2>
        <p className="text-xs" style={{ color: T.textDim }}>Click pe un dulap pentru navigare rapida</p>
      </div>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="minimap-grid">
      {treeData.map(plant => plant.cabinets.map(cab => {
        const totalPos = cab.total_bins || 0;
        const occupied = cab.occupied_bins || 0;
        const rate = totalPos > 0 ? Math.round((occupied / totalPos) * 100) : 0;
        const isSelected = selectedNode?.cabinetName === cab.name && selectedNode?.plantId === plant.id;
        return (
          <div key={`${plant.id}_${cab.name}`}
            data-testid={`minimap-cab-${cab.name}`}
            className={`group relative rounded-xl border p-4 cursor-pointer transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_8px_30px_rgba(59,130,246,0.15)] ${isSelected ? 'ring-2 ring-blue-500 shadow-[0_0_25px_rgba(59,130,246,0.25)]' : ''}`}
            style={{ background: T.paper, borderColor: isSelected ? T.primary : T.border }}
            onClick={() => { selectNode('cabinet', { plantId: plant.id, plantName: plant.name, cabinetName: cab.name, data: cab }); setViewMode('cabinet'); }}>
            <div className="mb-3 grid grid-cols-8 gap-0.5">
              {[...cab.shelves].reverse().flatMap(s => s.positions).slice(0, 32).map((pos, i) => (
                <div key={i} className="w-full aspect-square rounded-sm" style={{ background: pos.stock_count > 0 ? T.success + '80' : T.subtle }} />
              ))}
            </div>
            <div className="flex items-center justify-between">
              <div>
                <p className="font-bold text-sm">{cab.name}</p>
                <p className="text-[10px]" style={{ color: T.textDim }}>{plant.name} &middot; {cab.shelves.length} rafturi</p>
              </div>
              <div className="text-right">
                <p className={`text-lg font-extrabold font-mono ${rate > 70 ? 'text-emerald-400' : rate > 30 ? 'text-yellow-400' : 'text-red-400'}`}>{rate}%</p>
                <p className="text-[10px] font-mono" style={{ color: T.textDim }}>{occupied}/{totalPos}</p>
              </div>
            </div>
            <div className="mt-2 h-1.5 rounded-full overflow-hidden" style={{ background: T.subtle }}>
              <div className="h-full rounded-full transition-all duration-500" style={{ width: `${rate}%`, background: rate > 70 ? T.success : rate > 30 ? T.warning : T.danger }} />
            </div>
            <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center pointer-events-none">
              <div className="px-3 py-1.5 rounded-lg bg-blue-600/90 text-white text-xs font-bold shadow-lg">
                <MousePointer2 className="w-3 h-3 inline mr-1" />Deschide
              </div>
            </div>
          </div>
        );
      }))}
    </div>
    {treeData.length === 0 && (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <Navigation className="w-16 h-16 mx-auto mb-4 opacity-20" style={{ color: T.textDim }} />
          <p className="text-sm" style={{ color: T.textMuted }}>Niciun dulap disponibil</p>
        </div>
      </div>
    )}
  </div>
);
